module.exports = __webpack_public_path__ + "static/media/radio.c3a5d537.svg";